import { AuthService } from '$services/auth/auth.service'
import { IconsService } from '$services/icons/icons.service'
import { FormState } from '$types'
import { Country } from '@angular-material-extensions/select-country'
import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { ViewContainerRef } from '@angular/core';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css'],
})
export class SignupPageComponent implements OnInit {

  registerForm!: FormGroup
  formState: FormState = {
    currentStep: 0,
    finished: false,
    showNext: false,
    steps: ['register_identification', 'register_personnal', 'register_actions'],
    showPrev: false,
    showSaveDraft: false
  }
  defaultValue: Country = {
    alpha2Code: "FR",
    alpha3Code: "FRA",
    callingCode: "+33",
    name: "France",
    numericCode: "250"
  }
  success: boolean = false
  error: boolean = false
  conflictError: boolean = false
  failure_message: any;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly authService: AuthService,
    private readonly icons: IconsService,
    private readonly translateService: TranslateService,
    private readonly snackBar: MatSnackBar,
    private readonly viewContainerRef: ViewContainerRef
  ) {
    this.icons.registerIcon(['device-floppy', 'check', 'chevron-left', 'chevron-right']);
    this.failure_message = this.translateService.instant('signup.unique_id');
  }
  getFormControlIconClassnamePassword(): string {
    return this.registerForm.get('password')!.valid &&
      this.registerForm.get('confirm_password')!.valid &&
      (this.registerForm.get('password')?.value === this.registerForm.get('confirm_password')?.value) ? 'register__input__check-icon' : 'register__input__check-icon-hidden'
  }
  getFormControlIconClassname(controlName: string[] | string): string {

    if (typeof controlName === 'string') {
      return this.registerForm.get(controlName)!.valid ?

        'register__input__check-icon' : 'register__input__check-icon-hidden'
    }
    if (Array.isArray(controlName)) {

      const allok = controlName.map(s => this.registerForm.get(s)!.valid).reduce((p, c) => p && c)

      return allok ? 'register__input__check-icon' : 'register__input__check-icon-hidden'
    }

    return 'register__input__check-icon-hidden'
  }
  getStepClassname(): string {
    if (this.success) { return 'register-success' }
    if (this.error) { return 'register-error' }
    if (this.conflictError) { return 'register-conflictError' }
    return this.formState.steps[this.formState.currentStep]
  }
  onCountrySelected($event: Country) {
    console.log($event)

  }

  displayGender(): string {

    if (this.registerForm.value) {
      return ''
    }

    switch (this.registerForm.value?.gender) {
      case 'male':
        return 'M.'
      case 'female':
        return 'Mme'
      case 'other':
        return ''

      default:
        throw new Error('gender not recognized : ' + this.registerForm.value?.gender)
    }
  }

  ngOnInit(): void {
    this.formState = {
      currentStep: 0,
      finished: false,
      showNext: true,
      steps: ['register_identification', 'register_personnal', 'register_actions'],
      showPrev: false,
      showSaveDraft: false
    }
    this.registerForm = this.formBuilder.group({
      username: [
        null,
        [
          Validators.required,
          Validators.pattern('^[a-zA-Z0-9_]{3,32}$'),
        ],
      ],
      email: [
        null,
        [
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ],
      ],
      password: this.requiredAndLength(8),
      confirm_password: this.requiredAndLength(8),
      gender: [null, [Validators.required]],
      lastName: this.requiredAndLength(1),
      firstName: this.requiredAndLength(1),
      address: this.requiredAndLength(3),
      postalCode: this.requiredAndLength(4),
      city: this.requiredAndLength(1),
      countrySelect: this.requiredAndLength(2),
      secfAccount: [null, [Validators.pattern('^[0-9]{6}[a-zA-Z]{1}$'),]],
      landlinePhoneNumber: [null],
      mobilePhoneNumber: [null],
      newsletter: [false],
    })
  }

  isUsernameCharacter(evt: KeyboardEvent): boolean {
    const validUsernameCar: RegExp = /\w/
    return validUsernameCar.test(evt.key)
  }

  requiredAndLength(length: number) {
    return [null, [Validators.required, Validators.minLength(length)]]
  }

  isCurrentStepValid(): boolean {
    switch (this.formState.currentStep) {
      case 0:
        return this.registerForm.get('username')!.valid &&
          this.registerForm.get('email')!.valid &&
          this.registerForm.get('password')!.valid &&
          this.registerForm.get('confirm_password')!.valid &&
          (this.registerForm.get('password')?.value === this.registerForm.get('confirm_password')?.value)

      case 1:
        return this.registerForm.get('gender')!.valid &&
          this.registerForm.get('lastName')!.valid &&
          this.registerForm.get('firstName')!.valid &&
          this.registerForm.get('address')!.valid &&
          this.registerForm.get('postalCode')!.valid &&
          this.registerForm.get('city')!.valid &&
          this.registerForm.get('countrySelect')!.valid &&
          this.registerForm.get('secfAccount')!.valid

      default:
        return false

    }
  }

  onSubmit(e: SubmitEvent): void {
    e.preventDefault()

    this.registerForm.value.country = this.registerForm.value.countrySelect?.name
    this.authService.register(this.registerForm.value).subscribe({
      next: data => {
        this.showSuccessRegister()
      },
      error: err => {
        this.showSignupSnackbar()
        this.formState.showPrev = true
        this.formState.showNext = false
        this.formState.finished = false
        this.success = false
        this.error = true
        if (err.status === 409) {
          this.conflictError = true
          this.error = false
        }
      }
    })
  }
  showSuccessRegister() {

    this.formState.showPrev = false
    this.formState.showNext = false
    this.formState.finished = false
    this.success = true
    this.error = false
    this.conflictError = false
  }
  prevStep(): void {

    this.formState.currentStep = (this.formState?.currentStep ?? 1) - 1


    if (this.formState.currentStep == 0) {

      this.formState.showPrev = false
      this.formState.showNext = true

    } else {

      this.formState.showPrev = true
      this.formState.showNext = true

    }
    this.formState.finished = false
    this.success = false
    this.error = false
    this.conflictError = false


  }

  nextStep(): void {
    this.formState.currentStep = (this.formState?.currentStep ?? 0) + 1

    this.formState.showPrev = true
    this.formState.finished = false
    if (this.formState.currentStep > this.formState.steps.length - 1) {
      this.formState.currentStep = this.formState.steps.length - 1
    }
    if (this.formState.currentStep == this.formState.steps.length - 1) {
      this.formState.showNext = false
      this.formState.finished = true
    }
    this.success = false
    this.error = false
    this.conflictError = false
  }

  showSignupSnackbar(): void {
    const config = new MatSnackBarConfig();
    config.duration = 500000;
    config.verticalPosition = 'bottom';
    config.horizontalPosition = 'center';
    config.panelClass = ['signup-snackbar-panel'];
    config.viewContainerRef = this.viewContainerRef;
    const snackBarRef = this.snackBar.open('Nom d\'utilisateur ou email déjà utilisé !  veuillez en choisir d\'autres.', 'OK', config);
  }


}
